/**
 * 발주 검증 / 제출
 *
 * Baljoo 클래스에서 발주 검증·제출 흐름을 담당하는 헬퍼.
 * Baljoo 인스턴스를 생성자에 받아 this.b 로 보관, 부모 상태에 접근한다.
 */
import Util from '../../Common/Util';

export default class Submit {
    constructor(baljoo) {
        this.b = baljoo;
    }

    /**
     * 발주 필수입력항목이 모두 채워졌는지 체크
     * @returns {int}  0(필수항목 누락), 1(부가항목누락), 2(누락없음)
     */
    isAllFilled() {
        // 필수항목
        if (!this.isHowtopaySet()) return 0;
        if (!ORDER['contract_address']) return 0;
        if (!ORDER['car_workhour']) return 0;
        if (!ORDER['car_range']) return 0;

        return 2;
    }

    /**
     * 결제책임을 선택안했는지 여부
     */
    isHowtopaySet() {
        let is_howtopay = true;
        if (ORDER['order_type'] != '92') {//예약오더는 결제책임과 무관하다
            let p = ORDER['howtopay'];
            if (p == 0) is_howtopay = false;
            else if (p == 1 && ORDER['sign_howlong_int'] < 1) is_howtopay = false; // 싸인인데 기간이 지정이 안되어있다면
        }
        return is_howtopay;
    }

    /**
     * 도착시간(작업시간)이 유효한지 체크
     * ✅ 수동 긴급 발주 : 긴급발주 버튼을 누르는 경우 현재시간+40분 후를 도착시간으로 설정한다.
     * ✅ 자동 긴급 발주 : 도착시간이 현재시간기준 1시간 이내이면 명시적으로 긴급버튼을 누르지 않아도 자동으로 "긴급" 발주 처리한다.
     * ✅ 수동 과 자동의 차이점
     * - 어플발주는 남은시간이 20분 이상이어야 발주가능하다. 관리자도 예외없다.
     * - 수동긴급발주는 남은시간이 20분이 안되면 자동으로 도착시간을 연장해주고 발주된다.
     * - 자동긴급발주는 남은시간이 20분이 안되면 경고메세지를 표시하고 발주가 멈춘다.
     */
    isValidateWorktime(order_type) {
        // 어플 이외에는 시간체크 안한다.
        if (order_type != '0') return true;
        // 수정모드에서는 시간체크 안한다.
        if (editMode == 'myorderedit') return true;

        let work_time = ORDER['work_time']; // 도착시간
        if (dayjs().format('YYYY-MM-DD HH:mm:00') > work_time) {
            Util.swalert("작업일이 현재시간 이전입니다.\n작업시간을 다시 설정해 주세요");
            return false;
        }

        let remainSeconds = null;

        // 1) 현재시간 기준 최소 20분의 여유가 있어야 한다.
        remainSeconds = dayjs(work_time).diff(dayjs(), 'second');
        let remainMinutes1 = Math.ceil(remainSeconds / 60);// 도착시간 - 현재시간
        if (remainMinutes1 < 20) {
            Util.swalert(`도착 시간이 최소 20분 이후여야 합니다.(남은시간 : ${remainMinutes1}분)`);
            return false;
        }

        // 2) 설정시간 기준 40분의 여유가 있어야한다. (유저가 시간설정후 이것저것하다가 시간 경과할수있는걸 감안)
        let startTime = dayjs();
        if (this.b.startTime) startTime = this.b.startTime;
        remainSeconds = dayjs(work_time).diff(startTime, 'second');
        let remainMinutes2 = Math.ceil(remainSeconds / 60);// 도착시간 - 설정시간(도착시간을 설정한시간)
        if (remainMinutes2 < 40) {
            Util.swalert(`도착 시간이 최소 40분 이후여야 합니다.(남은시간 : ${remainMinutes1}분)`);
            return false;
        }

        return true;
    }

    /**
     * 작업 시작시간과 소요시간 validation 체크
     * TODO : 고도화 하기
     */
    isValidateWorkhour(order_type) {
        const car_workdaytype = ORDER['car_workdaytype'];
        if (order_type != '92') {
            let hm = dayjs(ORDER['work_time']).format('HH:mm');
            if (car_workdaytype == '오전' && hm > '09:30') {
                Util.swalert("작업시간이 09:30 이후면\n작업 유형을 오전으로 설정하실 수 없습니다.\n 작업도착시간 또는 작업 유형을 변경해 주세요", "");
                return false;
            }
            if (car_workdaytype == '오후' && (hm < '12:00' || hm >= '17:00')) {
                Util.swalert("작업시간이 12~17시가 아니면\n 작업 유형을 오후로 설정하실 수 없습니다.\n작업도착시간 또는 작업 유형을 변경해 주세요", "");
                return false;
            }
        }
        return true;
    }

    /**
     * 저단가 체크
     */
    /**
     * 비율형 저단가 — 표준가 대비 몇 %까지 내려도 되는가. 발주를 **막는** 기준이다.
     * 서버 정본은 `PriceCalculator::isLowPrice()` — 둘이 같아야 한다.
     * (스카이 저단가는 톤수별 절대금액이고 막지 않는다 — confirmSkyLow)
     */
    isLowOrderPrice() {
        // 사다리1톤짐은 체크안함
        if (ORDER['car_workhour'] == '1' && ORDER['car_workdaytype'] == '톤') return false;

        const p1 = Util.int(ORDER['car_price_standard']);
        const p2 = Util.int(ORDER['car_price']);
        let limit = 0.65; // 동일업종 발주시 35% 제한
        if (ORDER['car_type'] != MEMBER['mem_car_type']) limit = 0.9; // 타업종 발주시 10% 제한

        if (MEMBER['mem_driver_type'] == '수발주자' && p2 < p1 * limit) return true;

        return false;
    }

    /**
     * 발주하기전에 체크하기
     * @param order_type (91:임의, 92:일지, 94:외부,95:지정발주, 0:어플발주, -1:수정모드)
     * @param edit_act 수정모드시의 액션 빈값(신규발주),save(오더수정), send(오더수정+재발주)
     */
    checkSubmit(order_type, edit_act = '') {
        const self = this;
        // 발주제한이 있는지 체크
        if (!edit_act && isLimited) {
            Util.swalert('발주가 제한되어 발주 하실 수 없습니다.');
            return;
        }

        if (order_type == '-1') {// 수정모드일때는 기존의 오더타입을 유지한다.
            order_type = ORDER['order_type'];
        }

        // 스카이 저단가는 어플발주(0)만 대상이다. 신규발주 화면은 경로가 정해지기 전이라 어플발주로
        // 보고 수수료를 미리 내려둔다(Baljoo.checkSkyLowPrice) — 다른 경로로 내면 그걸 되돌린다.
        // 안 되돌리면 정책이 내린 수수료없음이 발주자가 고른 값으로 저장된다.
        if (order_type != '0' && this.b.skyLowFeeForced) {
            this.b.skyLowFeeForced = false;
            ORDER['is_fee'] = 1;
            this.b.print('fee');
        }

        // 필수항목이 입력안된게 있으면 해당 다이얼로그를 띄운다.
        if (this.isAllFilled() == 0) {
            this.b.openRequiredSlide(true);
            return;
        }

        const bonsaCol = $('#bonsa_col').val();
        if (Util.isSosokSamsung(ORDER['order_sosok']) && bonsaCol.length < 10) {
            Util.swalert('삼성전자 수임번호가 없습니다.\n수임번호를 입력해주세요');
            return;
        }
        const work_time = ORDER['work_time'];
        this.b.setWorkTime(work_time);

        // 발주시간 체크
        if (!this.isValidateWorktime(order_type)) return false;

        // 작업 시작시간과 소요시간 validation 체크
        if (!this.isValidateWorkhour(order_type)) return false;

        ORDER['contract_name'] = $('#input_contract_name').val();
        ORDER['contract_number'] = $('#input_contract_number').val();
        ORDER['contract_fieldnumber'] = $('#input_contract_fieldnumber').val();
        ORDER['contract_message'] = $('#input_contract_message').val();
        ORDER['bonsa_col'] = $('#bonsa_col').val();
        ORDER['meta'] = '';
        // 소속별 메타 검증/직렬화
        if (this.b.strategy) {
            const v = this.b.strategy.validateMeta();
            if (!v.ok) {
                Util.swalert(v.msg, function () { if (v.focus) $(v.focus).focus(); });
                return;
            }
            this.b.strategy.applyMetaToOrder(ORDER);
        }

        // 불완전 발주여부
        ORDER.$t['is_mini'] = 0;
        if (this.isAllFilled() == 1) ORDER.$t['is_mini'] = 1;

        const p2 = Util.int(ORDER['car_price']);
        if (['0', '95'].includes(order_type)) {
            if (p2 == 0) {
                Util.swalert('금액을 설정해주세요.')
                return;
            }
            // 비율형 저단가 금지 — 신규발주는 관리자도 못 지나간다 (서버도 같은 판정을 한다:
            // OrderCreationService::submit). 금액수정(edit_act)만 관리자에게 열어 둔다 —
            // CS 가 금액을 조정하는 정상 업무이고 판정도 따로 있다(OrderPolicyService).
            const skipLow = G5['isAdmin'] && edit_act;
            if (!skipLow && this.isLowOrderPrice()) {
                Util.swalert('일정금액 이하는 발주할 수 없습니다.\n(단가를 지켜주세요.) ');
                return;
            }
        }

        // 저장모드 m
        ORDER.$t['m'] = 'I';
        if (edit_act) { // save, send
            ORDER.$t['m'] = 'U';

            // 재발주여부 re
            ORDER.$t['re'] = 0;
            if (edit_act == 'send') ORDER.$t['re'] = 1;
        }

        ORDER.$t['order_type'] = order_type;

        // 수정모드는 확인창보다 앞(Baljoo 의 .apply_order 핸들러)에서 이미 물었다.
        // 여기서 또 물으면 저단가 경고가 두 번 뜬다.
        const askSkyLow = (next) => edit_act ? next() : this.confirmSkyLow(next);

        // 발주
        switch (order_type) {
            case '0':
                askSkyLow(() => self.appBaljoo());
                break;
            case '94':// 외부
            case '95':// 지정
                const askDirect = () => {
                    let who = ORDER.$r['hp_name'];
                    let tel = Util.phoneNumber(ORDER.$r['hp']);
                    let title = `${who} (${tel}) 님에게 지정발주 하시겠습니까?`;
                    Util.swalert(title, function () {
                        self.submit();
                    }, ['예', '아니오']);
                };
                // 스카이 저단가는 어플발주만 — 지정·외부배차는 경고 없이 보낸다 (PriceCalculator::isSkyLowOrderType)
                askDirect();

                break;
            default://일지,임의
                this.submit();
        }
    }

    /**
     * 스카이 저단가 여부. 하한액은 서버가 ORDER['sky_low_limit'] 로 내려준다 (0:정책 대상 아님).
     */
    isSkyLowPrice() {
        return $j.F.Car.isSkyLow(ORDER);
    }

    /**
     * 발주 직전 스카이 저단가 경고 (2026-09-01~). **지금 저단가일 때만** 뜨고, 확인해야 next 로 넘어간다.
     *
     * 대상 톤수라는 이유만으로 미리 알리던 사전안내는 뺐다 — 저단가가 아닌 발주에까지 떠서
     * 대부분의 스카이 발주가 창을 하나 더 지나야 했다.
     */
    confirmSkyLow(next) {
        // isSkyLowPrice 가 아니라 isSkyLowWarn — 업체발주자는 묻지 않고 그냥 보낸다.
        // 수수료없음은 서버가 판정해서 그대로 적용된다.
        if ($j.F.Car.isSkyLowWarn(ORDER)) {
            this.confirmSkyLowNow(next);
            return;
        }
        next();
    }

    /**
     * 이미 저단가인 발주 — 발주하면 -6차·발주개수를 못 받고 수수료없음으로 굳는다.
     * 되돌리기 어려운 선택이라 붉은 경고로 묻는다.
     */
    confirmSkyLowNow(next) {
        $j.Ui.Dialog.open({
            tone:  'danger',
            title: '저단가 발주입니다',
            desc:  `하한 ${Util.formatNumber(Util.int(ORDER['sky_low_limit']))}원`,
            notes: [
                { k: '-6차 · 발주개수', v: '지급 안 됨' },
                { k: '수수료', v: '없음' },
            ],
            confirm:   '발주',
            onConfirm: next,
        });
    }

    /**
     * 오더 수정 확인창 — 무엇이 바뀌는지 전부 보여주고 받는다.
     *
     * 예전에는 금액이 바뀌었는지만 보고 '금액 변경이 발생했습니다 [변경적용/금액되돌리기]' 를 띄웠다
     * (2024-10 3f2dd9c62). 축 하나만 바꿀 수 있던 시절의 창이라 지금은 세 가지가 어긋난다 —
     *   · 수수료·결제책임이 함께 바뀌어도 '금액' 만 말한다
     *   · [금액되돌리기] 는 금액만 되돌리고 **저장을 안 한다** — 수수료·결제는 화면에 바뀐 채 남아
     *     되돌린 건지 취소한 건지 알 수 없다
     *   · 금액이 바뀌면 '수정사항을 적용하시겠습니까?' 가 아예 안 뜬다 (if/else 라서 배타적이었다)
     *   · 본사금액 조건은 분할(8f77c13c7) 때 떨어져 나가 협력사 오더에서 안 떴다
     *
     * 그래서 창을 하나로 합치고 바뀐 축을 전부 세운다. 금액 되돌리기는 **체크박스**로 남긴다 —
     * 금액은 사용자가 안 만져도 바뀌기 때문이다(기종·작업소요·도착시간을 고치면 calcPrice 가
     * 덮어쓴다). 직접 입력한 금액이면 되돌릴 이유가 없으므로 체크박스를 내지 않는다.
     */
    confirmEdit(order_type, edit_act) {
        const self = this;
        const pay  = (typeof G5 !== 'undefined' && G5['HOW_TO_PAY']) || {};

        const oldPrice = Util.int(ORDER['_car_price']), newPrice = Util.int(ORDER['car_price']);
        const priceChanged = oldPrice !== newPrice;

        // 본사금액은 협력사 오더에만 있는 축이다 — 장비불러 소속은 화면이 아예 안 쓴다(Render.print('price')).
        // 그리고 서버가 0 이면 장비대금으로 채우므로(OrderCreationService::save) 표시도 같은 값으로 접는다.
        // 안 그러면 calcPrice 가 bonsa 를 0 으로 덮은 순간 '본사금액 400,000 → 0원' 이라는 거짓말이 뜬다.
        const showBonsa = !Util.isSosokJbbuller(ORDER['order_sosok']);
        const oldBonsa  = Util.int(ORDER['_car_price_bonsa']) || oldPrice;
        const newBonsa  = Util.int(ORDER['car_price_bonsa'])  || newPrice;
        const bonsaChanged = showBonsa && oldBonsa !== newBonsa;

        const rows = [];
        if (priceChanged) rows.push({ k: '금액',    v: `${Util.formatNumber(oldPrice)} → ${Util.formatNumber(newPrice)}원` });
        if (bonsaChanged) rows.push({ k: '본사금액', v: `${Util.formatNumber(oldBonsa)} → ${Util.formatNumber(newBonsa)}원` });
        // 수수료는 화면값이 곧 결과가 아니다 — 저단가면 서버가 0 으로 깎는다
        // (OrderCreationService::save). 화면이 안 바꿨다고 표에서 빼면, 바로 앞의 저단가
        // 경고창은 '수수료 없음'이라 말했는데 이 표는 아무 말이 없어 두 창이 어긋난다.
        const feeReal = ($j.F.Car.isSkyLow(ORDER) ? 0 : Util.int(ORDER['is_fee']));
        if (Util.int(ORDER['_is_fee']) !== feeReal) {
            rows.push({ k: '수수료', v: feeReal ? '없음 → 있음' : '있음 → 없음' });
        }
        if (Util.int(ORDER['_howtopay']) !== Util.int(ORDER['howtopay'])) {
            rows.push({ k: '결제책임', v: `${pay[Util.int(ORDER['_howtopay'])] || '미선택'} → ${pay[Util.int(ORDER['howtopay'])] || '미선택'}` });
        }

        // 금액이 **딸려** 바뀐 경우에만 되돌릴 기회를 준다
        const canRevert = (priceChanged || bonsaChanged) && !this.b.priceEditedByUser;
        const revertHtml = canRevert
            ? `<label class="ui-dlg-check"><input type="checkbox" id="chk_revert_price">`
              + `금액은 원래대로 두기 (${Util.formatNumber(oldPrice)}원)</label>`
            : '';

        const apply = () => {
            if (canRevert && $('#chk_revert_price').prop('checked')) {
                ORDER['car_price'] = oldPrice;
                ORDER['car_price_bonsa'] = oldBonsa;
                self.b.print('price');
            }
            self.b.checkSubmit(order_type, edit_act);
        };

        // 캐시가 움직이는 축이 하나도 안 바뀌었으면 표 없이 짧게 묻는다 (작업시간·주소만 고친 경우)
        $j.Ui.Dialog.open({
            align:   rows.length ? 'left' : undefined,
            title:   edit_act === 'send' ? '수정사항을 적용하고 발주할까요?' : '수정사항을 적용할까요?',
            rows,
            htmlAfter: revertHtml,// 표를 읽고 나서 고르도록 rows 뒤에 세운다
            hint:    canRevert ? '기종·작업소요·도착시간을 바꾸면 금액이 다시 계산됩니다.' : '',
            confirm: '적용',
            cancel:  '취소',
            onConfirm: apply,
        });
    }

    /**
     * 어플발주 진행 — 업체발주자는 최종확인 모달을 한 번 더 거친다.
     */
    appBaljoo() {
        const self = this;
        if (MEMBER['mem_driver_type'] != '업체발주자' || editMode == 'myorderedit') {
            this.submit();
            return;
        }
        // 어플발주 최종확인 모달 (BS)
        $j.Ui.BS.open({
            target: '$j.F.Baljoo.ModalConfirm',
            data:   {
                order:   ORDER,
                onApply: () => self.submit(),
            },
        });
    }

    /**
     * 발주
     */
    submit() {
        const self = this;
        const data = { ...ORDER }; // 객체복제
        const is_mini = data.$t['is_mini']; // 불완전발주 여부
        const order_type = data.$t['order_type'];
        const mode = data.$t['m'];

        data.$t['mb_no'] = MEMBER['num']; // 발주자회원번호 ( 발주하는 동안 회원정보가 변경됬는지를 판별하기위해서, 특히 관리자에서 로그인 꼬이는 현상이 있다 )

        // $r -> $t
        const arr = ['worker_num', 'worker_carnum', 'hp_name', 'hp'];
        $.each(arr, function (index, value) {
            if (!data.$r[value]) return true; // continue
            data.$t[value] = data.$r[value];
        });
        data.$r = {};

        // 오더 수정이 아니면 기존오더번호는 없앤다.
        if (editMode != 'myorderedit') {
            data['num'] = 0;
        }
        if (this.b.isSubmitted) return;   // 중복 제출 가드 — 오버레이 표시 전에 막는다
        this.b.isSubmitted = true;
        $j.Common.Util.loadingOverlay(true);
        $.ajax({
            url:      '/m/ajax/baljoo',
            type:     'post',
            data,
            dataType: 'json',
            success:  function (data) {
                $j.Common.Util.loadingOverlay(false);
                if (data['result']) {
                    let url = '';
                    const ordernum = data['ordernum'];
                    switch (order_type) {
                        case '0':// 어플
                        case '95':// 지정
                            if (is_mini) {// 불완전 발주이면 불러톡으로 이동
                                url = `/m/chat`;
                            } else {
                                url = '/m/diary?showipicknum=' + ordernum;
                            }
                            break;
                        case '91':// 임의
                        case '92':// 예약
                        case '94':// 외부
                            url = '/m/diary?showipicknum=' + ordernum;
                            break;
                    }

                    let msg = '접수완료 되었습니다.';
                    if (order_type == '92' || editMode == 'myorderedit') msg = '저장 되었습니다.';

                    self.waitGo(msg, url, 1500);
                } else {
                    self.b.isSubmitted = false;
                    Util.swalert(data['message']);
                }
            }
        });
    }

    /**
     * 발주완료후 메세지 보여주고 몇초후 일지로 이동한다.
     * @param msg 토스트메세지
     * @param url 이동할 주소
     * @param t 몇ms후에 이동할거냐
     */
    waitGo(msg, url, t) {
        if ($('#modal_overlay').length == 0) {
            $(`<div id="modal_overlay"></div`).appendTo('body');
        } else {
            $('#modal_overlay').show();
        }
        $j.Ui.Toast.show(msg, { type: 'success', timeout: t });
        setTimeout(function () {
            location.href = url;
        }, t);
    }
}
